module.exports = __webpack_public_path__ + "img/qiye.75a16f8d.png";